import { useContext, useState } from "react";
import { Appbar, Text } from "react-native-paper";
import { HeaderDispatch, ProjectDetailContext } from "../../util/contexts";
import { QuestionList } from "../../components/QuestionList";
import { StackScreenProps } from "@react-navigation/stack";
import {
  projectDetailNavigationProps,
  questionListData,
} from "../../util/navigationProps";
import { ReportFlatlist } from "../../components/Flatlists";
import { useFocusEffect } from "@react-navigation/native";
import createSideNavigator from "../../components/SideNavigator";
import { reports } from "../../util/reports";
export const ReportMobile = ({
  route,
  navigation,
}: StackScreenProps<projectDetailNavigationProps, "Report">) => {
  const setHeaderOptions = useContext(HeaderDispatch);
  useFocusEffect(() => {
    setHeaderOptions({
      title: "Reports",
      left: <Appbar.BackAction onPress={() => navigation.goBack()} />,
    });
  });
  const thisProject = useContext(ProjectDetailContext);
  const everythingFilledOut =
    thisProject.cylinder?.everythingFilledOut &&
    thisProject.general?.everythingFilledOut &&
    thisProject.heatPump?.everythingFilledOut &&
    thisProject.heatingZones?.everythingFilledOut &&
    thisProject.heatingZones_lwt?.everythingFilledOut &&
    thisProject.hotWater?.everythingFilledOut;
  if (everythingFilledOut)
    return (
      <ReportFlatlist
        navigate={(
          name: keyof projectDetailNavigationProps,
          params: questionListData | undefined
        ) => navigation.navigate({ name: name, params: params })}
      />
    );
  else return <Text>Please fill out all the previous sections first</Text>;
};
export const ReportDesktop = ({
    route,
}: StackScreenProps<projectDetailNavigationProps, "Report">) => {
  const [highlightedStep, setHighlightedStep] = useState(0);
  const Side = createSideNavigator();
  const thisProject = useContext(ProjectDetailContext);
  const everythingFilledOut =
    thisProject.cylinder?.everythingFilledOut &&
    thisProject.general?.everythingFilledOut &&
    thisProject.heatPump?.everythingFilledOut &&
    thisProject.heatingZones?.everythingFilledOut &&
    thisProject.heatingZones_lwt?.everythingFilledOut &&
    thisProject.hotWater?.everythingFilledOut &&
    thisProject.noise?.calculationFactors?.everythingFilledOut;
  if (everythingFilledOut)
    return (
      <Side.Navigator
        initialRouteName="Questions"
        screenOptions={{
          left: (
            sideNavigate: (
              name: keyof projectDetailNavigationProps,
              params?: questionListData
            ) => void,
            unmountSide
          ) =>
            ReportFlatlist({
              navigate: (
                name: keyof projectDetailNavigationProps,
                params: questionListData | undefined
              ) => sideNavigate(name, params),
              highlightedStep: highlightedStep,
              setHighlightedStep: (number) => {
                setHighlightedStep(number);
                if (number == -1) unmountSide();
              },
            }),
        }}
      >
        <Side.Screen
          name="Questions"
          component={QuestionList}
          initialParams={{
            displayedQuestionCollection: reports(
              thisProject.general?.contractBeforeSurvey || false,
              thisProject.general?.inOfficeContract || false
            )[0].question_collection,
            valueStoragePath: "projects",
            valueStorageDocument: thisProject.id,
            categoryOfAnswers: "report",
            nestedPath: reports(
              thisProject.general?.contractBeforeSurvey || false,
              thisProject.general?.inOfficeContract || false
            )[0].nestedPath,
            extraData: reports(
              thisProject.general?.contractBeforeSurvey || false,
              thisProject.general?.inOfficeContract || false
            )[0].extraData,
          }}
        />
      </Side.Navigator>
    );
  else return <Text>Please fill out all the previous sections first</Text>;
};
